<script>
  export default {
    name: 'iconLayout',
    model: {
      prop: 'value',
      event: 'change'
    },
    props: {
      value: {
        type: Object,
        default: () => ({
          layoutType: '1', // 1: 单行模板, 2: 多行模板
          icons: []
        })
      }
    },
    data() {
      return {
        // 示例图标数据
        singleRowIcons: [
          { id: 1, name: '跳转银行', icon: 'bank-icon.png' },
          { id: 2, name: '领取现金', icon: 'cash-icon.png' },
          { id: 3, name: '各地客服', icon: 'service-icon.png' },
          { id: 4, name: '电子发票', icon: 'invoice-icon.png' },
          { id: 5, name: '安全中心', icon: 'security-icon.png' }
        ],
        multiRowIcons: [
          { id: 1, name: '跳转银行', icon: 'bank-icon.png' },
          { id: 2, name: '领取现金', icon: 'cash-icon.png' },
          { id: 3, name: '各地客服', icon: 'service-icon.png' },
          { id: 4, name: '电子发票', icon: 'invoice-icon.png' },
          { id: 5, name: '安全中心', icon: 'security-icon.png' },
          { id: 6, name: '跳转银行', icon: 'bank-icon.png' },
          { id: 7, name: '领取现金', icon: 'cash-icon.png' },
          { id: 8, name: '各地客服', icon: 'service-icon.png' },
          { id: 9, name: '电子发票', icon: 'invoice-icon.png' },
          { id: 10, name: '安全中心', icon: 'security-icon.png' }
        ]
      }
    },
    computed: {
      form: {
        get() {
          return this.value
        },
        set(newVal) {
          this.$emit('change', newVal)
        }
      }
    },
    methods: {
      handleLayoutChange(type) {
        this.form.layoutType = type
        // 根据选择的模板类型设置默认图标
        // if (type === '1') {
        //   this.form.icons = [...this.singleRowIcons]
        // } else {
        //   this.form.icons = [...this.multiRowIcons]
        // }
        this.$emit('change', this.form)
      },
      getRandomColor() {
        const colors = [
          '#67C23A', // 绿色
          '#F56C6C', // 红色
          '#E6A23C', // 黄色
          '#409EFF', // 蓝色
          '#909399' // 灰色
        ]
        return colors[Math.floor(Math.random() * colors.length)]
      }
    }
  }
</script>

<template>
  <div class="icon-layout">
    <div class="layout-title">*请选择 icon 样式模板</div>

    <!-- 模板选择 -->
    <div class="layout-options">
      <div class="layout-option" v-for="item in form.icons" :key="item.id">
        <el-radio v-model="form.layoutType" :label="item.id" @change="handleLayoutChange(item.id)">
          {{ item.name }}
        </el-radio>

        <!-- 单行模板 -->
        <div class="layout-preview" v-if="item.name.includes('单行')">
          <div class="preview-title">样式预览:</div>
          <div class="preview-content single-row">
            <img src="@/assets/images/iconLayout/icon_1.png" />
          </div>
        </div>

        <!-- 多行模板 -->
        <div class="layout-preview" v-else-if="item.name.includes('多行')">
          <div class="preview-title">样式预览:</div>
          <div class="preview-content multi-row">
            <img src="@/assets/images/iconLayout/icon_n.png" />
          </div>
        </div>
      </div>

      <!-- 多行模板 -->
      <!--      <div class="layout-option">-->
      <!--        <el-radio v-model="form.layoutType" :label="1" @change="handleLayoutChange('2')">-->
      <!--          多行 5*n 模板-->
      <!--        </el-radio>-->

      <!--        -->
      <!--      </div>-->
    </div>
  </div>
</template>

<style scoped lang="scss">
  .icon-layout {
    padding: 20px;

    .layout-title {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 20px;
    }

    .layout-options {
      display: flex;
      flex-direction: column;
      gap: 30px;

      .layout-option {
        margin-bottom: 20px;

        .layout-preview {
          margin-top: 10px;
          margin-left: 24px;

          .preview-title {
            font-size: 14px;
            color: #666;
            margin-bottom: 10px;
          }

          .preview-content {
            background-color: #fff;
            border-radius: 8px;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            padding: 15px;

            &.single-row {
              display: flex;
              justify-content: space-between;

              .icon-item {
                display: flex;
                flex-direction: column;
                align-items: center;
                width: 60px;

                .icon-placeholder {
                  width: 40px;
                  height: 40px;
                  border-radius: 50%;
                  margin-bottom: 5px;
                }

                .icon-name {
                  font-size: 12px;
                  color: #333;
                  text-align: center;
                }
              }
            }

            &.multi-row {
              .row {
                display: flex;
                justify-content: space-between;
                margin-bottom: 15px;

                &:last-child {
                  margin-bottom: 0;
                }

                .icon-item {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  width: 60px;

                  .icon-placeholder {
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    margin-bottom: 5px;
                  }

                  .icon-name {
                    font-size: 12px;
                    color: #333;
                    text-align: center;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>
